import { useQuery } from '@tanstack/react-query';

import {
  getFilteredInsights,
  GetFilteredInsightsProps,
} from '~/services/insights/insights-service';

export const QUERY_KEY_FILTERED_INSIGHTS = 'QUERY_KEY_FILTERED_INSIGHTS';

export const useFilteredInsights = (
  body: GetFilteredInsightsProps,
  limit = 1000
) =>
  useQuery({
    queryKey: [QUERY_KEY_FILTERED_INSIGHTS, body],
    queryFn: () => getFilteredInsights({ ...body, limit }),
    enabled: !!body.entity?.length,
    staleTime: 0,
    gcTime: 0,
  });
